export enum ApiTypes {
    GET = 'get',
    POST = 'post',
    PUT = 'put',
    DELETE = 'delete',
}
